/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientOptions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Existing from './Existing/index'
import New from './New/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientOptions({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentOverlayPatientOptionValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_option',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: appointmentOverlayPatientOptionValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'New'}>
<New
  viewPath={`${viewPath}/New`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Existing'}>
<Existing
  viewPath={`${viewPath}/Existing`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}